import { render, staticRenderFns } from "./PrivacyPolicyPt.vue?vue&type=template&id=a3d9c73a&"
import script from "./PrivacyPolicyPt.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyPt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports